import PropTypes from "prop-types";
import WildcardSwitch from "layout/dictionary/edit/components/WildcardSwitch";
import { useDispatch, useSelector } from "react-redux";
import { showModal } from "slices/app/actions/modals";
import { modalTypes } from "constants/types";
import { acronymIgnoreListTurnOffRegex } from "components/Modal/confModalTypes";
import { termProps } from "layout/dictionary/edit/types";
import { setRegexPanel } from "slices/settings/slices/acronymIgnoreSlice";
import { selectAcronymIgnore } from "slices/settings/selectors";

const Regex = ({ isSelected, ignoreListItem, wrapperRef, editMode }) => {
  const dispatch = useDispatch();
  const isEnabled = ignoreListItem.regex;
  const { ignoreList } = useSelector(selectAcronymIgnore);
  const index = ignoreList.findIndex(
    (item) => item.term === ignoreListItem.term
  );

  const handleSwitchChange = () => {
    if (!isEnabled) {
      dispatch(setRegexPanel({ showRegex: true, ignoreListItem }));
    } else {
      dispatch(
        showModal(
          modalTypes.CONFIRMATION,
          acronymIgnoreListTurnOffRegex(
            index,
            { ...ignoreListItem, regex: false },
            dispatch
          )
        )
      );
    }
  };

  return (
    <div
      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      tabIndex={0}
      className="wildcard_cell"
      data-testid="regex-cell"
    >
      <WildcardSwitch
        id="switch-id"
        switchRef={wrapperRef}
        isSelected={isSelected}
        currentSwitchState={isEnabled}
        disabled={!editMode}
        handleChange={handleSwitchChange}
      />
    </div>
  );
};

Regex.propTypes = {
  isSelected: PropTypes.bool,
  ignoreListItem: PropTypes.shape(termProps),
  wrapperRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
  editMode: PropTypes.bool.isRequired,
};

export default Regex;
